import React, { useState } from "react";
import * as Yup from "yup";
import { Button, Checkbox, Col, Modal, Row, Typography } from "antd";
import { useFormik } from "formik";
import FundsService from "@services/Funds.service";

type Props = {
  setAccessingFundsAgreementCreatedAt: () => void;
};

import * as style from "./ImportantNoticeModalStyle.module.scss"

const validationSchema = () =>
  Yup.object({
    agreement: Yup.bool().oneOf([true], "Field must be checked"),
  });

const ImportantNoticeModal = (props: Props) => {
  const [modalOpen, setModalOpen] = useState(true);
  const formik = useFormik({
    initialValues: {
      agreement: false,
    },
    onSubmit: async () => {
      try {
        await FundsService.updateAccessingFunds();
        setModalOpen(false);
        props.setAccessingFundsAgreementCreatedAt();
      } catch (error) {
        throw new Error("updateAccessingFunds failed");
      }
    },
    validationSchema,
    validateOnMount: true,
  });

  return (
    <Modal
      title="Important Notice"
      open={modalOpen}
      closable={false}
      width={720}
      footer={null}
    >
      <form onSubmit={formik.handleSubmit}>
        <Row>
          <Col>
            <Typography.Title level={5}>Custody of funds</Typography.Title>
            <Typography.Paragraph>
              Client funds are held in the custody of the Virtual Assets Broker
              situated in the British Virgin Islands. The BF Platform Operator,
              based in the Cayman Islands, does not provide custody services for
              clients' funds, nor does it engage in any virtual asset services.
            </Typography.Paragraph>
          </Col>
        </Row>

        <Row>
          <Col>
            <Typography.Title level={5}>
              Trading of Virtual Assets
            </Typography.Title>
            <Typography.Paragraph>
              All trading services in Virtual Assets on the BF Platform, which
              consists in BTC, ETH and USDT trades are solely operated by the
              Virtual Assets Broker. The BF Platform Operator does not provide
              any custody or trading service in relation to Virtual Assets.
            </Typography.Paragraph>
          </Col>
        </Row>

        <Row>
          <Col>
            <Typography.Paragraph>
              For more information, please review our terms and conditions{" "}
              <a
                className={style.link}
                href="https://bnktothefuture.com/terms-conditions/"
                target="_blank"
              >
                here.
              </a>
            </Typography.Paragraph>
          </Col>
        </Row>

        <Row>
          <Col>
            <Checkbox {...formik.getFieldProps("agreement")}>
              <Typography.Paragraph className={style.label}>
                I irrevocably and unconditionally confirm that I have thoroughly
                read and understood the terms and conditions of BNK To the
                Future Online Investment Platform and have consulted, as I have
                deemed necessary, with legal counsel in respect of same.
              </Typography.Paragraph>
            </Checkbox>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Button
              type="primary"
              onClick={formik.submitForm}
              block
              disabled={!formik.isValid}
              loading={formik.isSubmitting}
            >
              Proceed
            </Button>
          </Col>
        </Row>
      </form>
    </Modal>
  );
};

export default ImportantNoticeModal;
